export enum SortOrder {
	CaloriesAsc = 'CaloriesAsc',
	CaloriesDesc = 'CaloriesDesc',
	CarbonDioxideAsc = 'CarbonDioxideAsc',
	CarbonDioxideDesc = 'CarbonDioxideDesc',
	DensityAsc = 'DensityAsc',
	DensityDesc = 'DensityDesc',
	LastEditedDateAsc = 'LastEditedDateAsc',
	LastEditedDateDesc = 'LastEditedDateDesc',
	NameAsc = 'NameAsc',
	NameDesc = 'NameDesc',
	PriceAsc = 'PriceAsc',
	PriceDesc = 'PriceDesc',
	StartingDateAsc = 'StartingDateAsc',
	StartingDateDesc = 'StartingDateDesc',
	TitleAsc = 'TitleAsc',
	TitleDesc = 'TitleDesc',
	Relevance = 'Relevance',
}
